<template>
  <div>
    <div class="main-content">
      <div id="boxloading"></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <router-link tag="li" :to="{ name: 'user'}">
              <a>ユーザー</a>
            </router-link>
            <li class="active">新規ユーザー登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>新規ユーザー登録</h3>
          </div>
          <a href="#question" id="confirm" data-toggle="modal" style="display:none">show</a>
        </div><!-- /.page-header -->
        <div class="page-content register_user">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
            <div class="alert alert-success" v-if="message && GroupIdSubmittedFail.length === 0 && PcodeSubmittedFail.length == 0 && sucessStatus">
              {{ message }}
            </div>
            <div class="alert alert-danger" v-if="errorMessageLogs!==''">
              {{ errorMessageLogs }}
            </div>
            <div class="alert alert-danger" v-if="GroupIdSubmittedFail.length > 0 && PcodeSubmittedFail.length === 0 && sucessStatus"> <!-- only gate group error -->
              ユーザーは登録されましたが、ゲートグループの紐づけに失敗しています。<br>
              ユーザー編集より、ゲートグループの確認をしてください。
            </div>
            <div class="alert alert-danger" v-else-if="GroupIdSubmittedFail.length === 0 && PcodeSubmittedFail.length > 0 && sucessStatus"> <!-- only gate group error -->
              ユーザーは登録されましたが、個人コードの紐づけに失敗しています。<br>
              ユーザー編集より、個人コードの確認をしてください。
            </div>
            <div class="alert alert-danger" v-else-if="GroupIdSubmittedFail.length > 0 && PcodeSubmittedFail.length > 0 && sucessStatus"> <!-- both gate group and Pcode error -->
              ユーザーは登録されましたが、ゲートグループと個人コードの紐づけに失敗しています。<br>
              ユーザー編集より、ゲートグループと個人コードの確認をしてください。
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-2 center userav">
                <div class="col-xs-12 col-sm-12">
                  <span class="profile-picture">
                    <img id="user_avatar" class="editable img-responsive" alt="user avatar" src="../../../static/images/avatars/default-avatar.png" width="150" height="150" style="width:150px; height:150px; overflow:auto" />
                  </span>
                </div>
                <div class="col-xs-12 col-sm-12">
                  <label for="file_user_avatar" class="btn-upload" style="background:black;color:white;padding:5px 15px;margin-top:10px;cursor: pointer;">
                    画像ファイルを選択
                    <input type="file" name="avatar" style="display:none" id="file_user_avatar" accept='image/png'>
                  </label>
                </div>
                <span id="fileimg_error" class="error_m"></span>
              </div><!-- /.col -->
              <div class="col-xs-12 col-sm-10">
                <div class="profile-user-info">
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザーID <font class="input-required">※必須</font></div>
                    <div class="profile-info-value">
                      <span id="userid_error" class="error_m"></span>
                      <input placeholder="ユーザーID" id="userid" type="text" name="userId" class="form-control input-sm" v-model="userInfor.userId" @blur="validateBeforeSubmit(1)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ログインパスワード <font class="input-required">※必須</font></div>
                    <label class="clearfix cusrow">
                      <span id="password_error" class="error_m"></span>
                      <input id="password" placeholder="パスワード" name="password" type="password" class="form-control input-sm" v-model="userInfor.password" @blur="validateBeforeSubmit(2)">
                    </label>
                    <span class="newpassword-showhide">
                      <span class="show-password" @click="showhidePassword('password' , 'show-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                      <span class="hide-password" @click="showhidePassword('password' , 'hide-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                    </span>
                    <div class="warringu">
                      ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で設定してください。
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名（登録名）<font class="input-required">※必須</font></div>
                    <div class="profile-info-value">
                      <span id="name_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="name" placeholder="ユーザー名" v-model="userInfor.name" @blur="validateBeforeSubmit(3)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ユーザー名（ふりがな）</div>
                    <div class="profile-info-value">
                      <span id="furigana_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="furigana" placeholder="ふりがな" v-model="userInfor.furigana" @blur="validateBeforeSubmit(4)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">メールアドレス</div>
                    <div class="profile-info-value">
                      <span id="mailaddress_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="mailaddress" placeholder="example@example.com" v-model="userInfor.email" @blur="validateBeforeSubmit(5)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">暗証番号</div>
                    <div class="profile-info-value">
                      <span id="passcode_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="passcode" placeholder="0000" v-model="userInfor.passCode" @blur="validateBeforeSubmit(6)">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">組織管理権限</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isAdmin">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート設定権限</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isPhoneAdmin">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">鍵共有権限</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.shareKeyBeValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ステータス</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="userInfor.isValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートグループ</div>
                    <div class="profile-info-value">
                      <!-- Gate group select -->
                      <span id="pcode_error" class="error_m">{{gateGroupErrorMessage}}</span>
                      <user-gate-group-select id="group-selection-container"
                        v-bind:userId="userId"
                        v-bind:startAddGroup="startAddGroup"
                        :loading.sync = "loading"
                        :gateGroupErrorMessage.sync = "gateGroupErrorMessage"
                        :isFinishGetDataGroup.sync = "isFinishGetDataGroup"
                        :isFinishAddGroup.sync = "isFinishAddGroup"
                        :GroupIdSubmittedFail.sync ='GroupIdSubmittedFail'
                        v-bind:resetDataGroupPcode="resetDataGroupPcode"> </user-gate-group-select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name" style="vertical-align:top">個人コード</div>
                    <div class="profile-info-value">
                      <span id="pcode_error" class="error_m">{{pcodeErrorMessage}}</span>
                       <app-user-pcode-select id="pcode-selection-container"
                        :assignedPcode.sync="assignedPcode"
                        :pcodeErrorMessage.sync="pcodeErrorMessage"
                        :PcodeSubmittedFail.sync="PcodeSubmittedFail"
                        :isPCodeFinishGet.sync="isPCodeFinishGet"
                        :isPcodeFinishAdd.sync="isPcodeFinishAdd"
                        v-bind:userId="userInfor.userId"
                        :loading.sync = "loading"
                        v-bind:startAddPcode="startAddPcode"
                        v-bind:resetDataGroupPcode="resetDataGroupPcode">
                        </app-user-pcode-select>
                    </div>
                  </div>
                   <div class="profile-info-row">
                    <div class="profile-info-name">SMS認証</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" :disabled ="(isMfa === 'false')" v-model="userInfor.isMfaSms">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">電話番号</div>
                    <div class="profile-info-value">
                      <span id="phonenumber_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm input" id="phonenumber" placeholder="" :disabled ="!isSMS" v-model="userInfor.phoneNumber" @blur="validateBeforeSubmit(9)">
                      <p style="margin-top:10px">0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。</p>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.1</div>
                    <div class="profile-info-value">
                      <span id="option1_error" class="error_m"></span>
                      <textarea class="form-control" id="option1" placeholder="備考.1" v-model="userInfor.option1" @blur="validateBeforeSubmit(7)"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.2</div>
                    <div class="profile-info-value">
                      <span id="option2_error" class="error_m"></span>
                      <textarea class="form-control" id="option2" placeholder="備考.2" v-model="userInfor.option2" @blur="validateBeforeSubmit(8)"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="action_box">
                      <router-link :to="{ name: 'user'}" class="btn cancel_bottom">
                        キャンセル
                      </router-link>
                      <button class="btn btn-info save_bottom" type="button" @click="pCodeChangeConfirm">
                        ユーザーを登録
                      </button>
                    </div>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="pCode-change" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">個人コードの関連付けユーザー</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">以下の個人コードの関連付けユーザーが変更されますがよろしいでしょうか？</span>
            <div>
              <div class="error-box" style="margin-top:20px">
                <template v-for="item in assignedPcode">
                  <p :key="item.pCodeId">ユーザーID：<font style="color:red">{{item.userId}}</font>に関連付けされた個人コード”<font style="color:red">{{item.pCodeId}}</font>”の関連付けユーザーが変更されます。</p>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm" style="width:100px" data-dismiss="modal">キャンセル</button>
          <button class="btn btn-sm btn-success" style="width:100px" data-dismiss="modal" @click="submitAddUser">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <!-- プロフィールModal -->
    <div id="question" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div>
              作成したユーザーのメールアドレスへ通知メールを送信しますか？
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success" style="width:100px" data-dismiss="modal" @click="yesChoice()">送信する</button>
            <button class="btn btn-sm" style="width:100px" data-dismiss="modal" @click="noChoice()">送信しない</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import UserGateGroupSelect from './UserGateGroupSelect.vue'
import UserPcodeSelect from './UserPcodeSelect.vue'

export default {
  components: {
    UserGateGroupSelect: UserGateGroupSelect,
    appUserPcodeSelect: UserPcodeSelect
  },
  data () {
    return {
      userInfor: {
        userId: '',
        password: '',
        name: '',
        furigana: '',
        email: '',
        phoneNumber: '',
        thumbnail: '',
        passCode: '',
        isMfaSms: '',
        isAdmin: false,
        isPhoneAdmin: false,
        shareKeyBeValid: false,
        isValid: true,
        option1: '',
        option2: '',
        isSendEmail: false
      },
      loading: false,
      flag: 0,
      flagU: false,
      flagP: false,
      base64: '',
      sucessStatus: false,
      error: '',
      message: '',
      errorMessageLogs: '',
      imgWidth: 0,
      imgHeight: 0,
      anwser: false,
      fileTmp: '',
      isEnabledSave: false, // IF true: Enabled button 保存, false: disabled button 保存,
      userId: '',
      gateGroupErrorMessage: '',
      startAddGroup: false,
      isFinishGetDataGroup: false,
      isFinishAddGroup: false,
      GroupIdSubmittedFail: [],
      // Pcode
      isPCodeFinishGet: false,
      isPcodeFinishAdd: false,
      PcodeSubmittedFail: [],
      pcodeErrorMessage: '',
      startAddPcode: false,
      resetDataGroupPcode: false,
      assignedPcode: [],
      isMfa: false,
      isSMS: false
    }
  },
  watch: {
    'userInfor.isMfaSms': function (newVal, oldVal) {
      $('#phonenumber_error.error_m').html('')
      $('.input').removeClass('error')
      if (newVal === false) {
        this.isSMS = false
      } else {
        this.isSMS = true
      }
    },
    isFinishGetDataGroup: function (newVal, oldVal) {
      console.log('isFinishGetDataGroup', newVal)
      if (newVal) {
        if (this.isPCodeFinishGet) {
          // this.sucessStatus = true
          // this.loading = false
          this.resetDataGroupPcode = false
        }
      }
    },
    isFinishAddGroup: function (newVal, oldVal) {
      console.log('isFinishAddGroup', newVal)
      if (newVal) {
        this.startAddPcode = true
      }
    },
    isPCodeFinishGet: function (newVal, oldVal) {
      console.log('isPCodeFinishGet', newVal)
      if (newVal) {
        if (this.isFinishGetDataGroup) {
          // this.sucessStatus = true
          // this.loading = false
          this.resetDataGroupPcode = false
        }
      }
    },
    isPcodeFinishAdd: function (newVal, oldVal) {
      if (newVal) {
        this.sucessStatus = true
        this.loading = false
        this.message = Config.ADD_USER_API_SUCCESS
        this.reset()
        this.resetGroupAndPcode()
        this.resetDataGroupPcode = true
      }
    }
  },
  mounted () {
    var vm = this
    vm.isMfa = localStorage.isMfa
    var _URL = window.URL
    $('#file_user_avatar').change(function (e) {
      var img
      var file = document.querySelector('input[type="file"]').files[0]
      vm.fileTmp = file
      if ((file = this.files[0])) {
        img = new Image()
        img.src = _URL.createObjectURL(file)
        img.onload = function () {
          vm.imgWidth = this.width
          vm.imgHeight = this.height
          vm.validateBeforeSubmit()
        }
      }
    })
  },
  methods: {
    showhidePassword (passwordId, classname, buttonname) {
      if (classname === 'show-password') {
        $('#' + passwordId).attr('type', 'text')
        $('.' + buttonname).find('.show-password').hide()
        $('.' + buttonname).find('.hide-password').show()
      } else {
        $('#' + passwordId).attr('type', 'password')
        $('.' + buttonname).find('.hide-password').hide()
        $('.' + buttonname).find('.show-password').show()
      }
    },
    getBase64 (file) {
      console.log(file)
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        document.getElementById('user_avatar').setAttribute(
          'src', reader.result
        )
      }
      reader.onerror = function (error) {
        console.log('Error: ', error)
      }
    },
    converImgtpBase64 (file) {
      var vm = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        var str = reader.result
        var imgurl = str.replace(/^data:image\/[a-z]+;base64,/, '')
        vm.userInfor.thumbnail = imgurl
      }
    },
    reset () {
      this.userInfor.userId = null
      this.userInfor.password = null
      this.userInfor.name = null
      this.userInfor.furigana = null
      this.userInfor.email = null
      this.userInfor.passCode = '0000'
      this.userInfor.phoneNumber = null
      this.userInfor.isMfaSms = false
      this.userInfor.isAdmin = false
      this.userInfor.isPhoneAdmin = false
      this.userInfor.shareKeyBeValid = false
      this.userInfor.isValid = true
      this.userInfor.option1 = null
      this.userInfor.option2 = null
      this.userInfor.isSendEmail = false
      this.anwser = false
    },
    resetGroupAndPcode () {
      this.startAddGroup = false
      this.isFinishAddGroup = false
      this.isPcodeFinishAdd = false
      this.startAddPcode = false
      this.assignedPcode = []
      this.pcodeErrorMessage = ''
      this.gateGroupErrorMessage = ''
    },
    validateBeforeSubmit (index) {
      this.flag = 0
      this.flagU = true
      this.flagP = true
      var vm = this
      if (this.userInfor.userId === null || this.userInfor.userId === '') {
        if (index === -1 || index === 1) {
          $('#userid_error').html('ユーザーIDは必須です。')
          $('#userid').addClass('error')
        }
        this.flagU = false
      } else {
        var isOk = /^[a-zA-Z0-9@.!#$&*+/=?^_`{|}~-]{4,96}$/.test(this.userInfor.userId)
        if (!isOk) {
          if (index === -1 || index === 1) {
            $('#userid_error').html('ユーザIDは半角英数字で4文字以上96文字以内で設定してください。')
            $('#userid').addClass('error')
          }
          this.flagU = false
        } else {
          if (index === -1 || index === 1) {
            $('#userid_error').html('')
            $('#userid').removeClass('error')
          }
          this.flagU = true
        }
      }
      if (this.userInfor.password === null || this.userInfor.password === '') {
        if (index === -1 || index === 2) {
          $('#password_error').html('ログインパスワードは必須です。')
          $('#password').addClass('error')
        }
        this.flagP = false
      } else if (!this.userInfor.password.match('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*).{8,64}$')) {
        if (index === -1 || index === 2) {
          $('#password_error').html('ログインパスワードは英大文字、英小文字、数字を組み合わせた8文字以上64文字以内で設定してください。')
          $('#password').addClass('error')
        }
        this.flagP = false
      } else {
        if (index === -1 || index === 2) {
          $('#password_error').html('')
          $('#password').removeClass('error')
        }
        this.flagP = true
      }
      if (this.userInfor.name === null || this.userInfor.name.trim() === '') {
        // ユーザー名（登録名）is required
        if (index === -1 || index === 3) {
          $('#name_error').html('ユーザー名（登録名）は必須です。')
          $('#name').addClass('error')
        }
        this.flag += 1
      } else {
        if (this.userInfor.name.length > 64) {
          // ユーザー名（登録名） > 64 chars
          if (index === -1 || index === 3) {
            $('#name_error').html('ユーザー名（登録名）は64文字以内で入力してください。')
            $('#name').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 3) {
            $('#name_error').html('')
            $('#name').removeClass('error')
          }
        }
      }
      if (this.userInfor.furigana !== null && this.userInfor.furigana !== '') {
        if (this.userInfor.furigana.length > 64) {
          if (index === -1 || index === 4) {
            $('#furigana_error').html('ユーザー名（ふりがな）は64文字以内で入力してください。')
            $('#furigana').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 4) {
            $('#furigana_error').html('')
            $('#furigana').removeClass('error')
          }
        }
      } else {
        // if furigana is not input
        if (index === -1 || index === 4) {
          $('#furigana_error').html('')
          $('#furigana').removeClass('error')
        }
      }
      if (this.userInfor.email !== null && this.userInfor.email !== '') {
        if (!this.userInfor.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/)) {
          if (index === -1 || index === 5) {
            $('#mailaddress_error').html('正しいメールアドレスを入力してください。')
            $('#mailaddress').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 5) {
            $('#mailaddress_error').html('')
            $('#mailaddress').removeClass('error')
          }
        }
      } else {
        // if email is not input
        if (index === -1 || index === 5) {
          $('#mailaddress_error').html('')
          $('#mailaddress').removeClass('error')
        }
      }
      if (this.userInfor.passCode !== null && this.userInfor.passCode !== '') {
        if (!this.userInfor.passCode.match(/^\d{4}$/)) {
          if (index === -1 || index === 6) {
            $('#passcode_error').html('暗証番号は半角数字で4文字入力してください。')
            $('#passcode').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 6) {
            $('#passcode_error').html('')
            $('#passcode').removeClass('error')
          }
        }
      } else {
        // if passCode is not input
        if (index === -1 || index === 6) {
          $('#passcode_error').html('')
          $('#passcode').removeClass('error')
        }
      }
      if (this.userInfor.option1 !== null && this.userInfor.option1 !== '') {
        if (this.userInfor.option1.length > 64) {
          if (index === -1 || index === 7) {
            $('#option1_error').html('備考は64文字以内で入力してください。')
            $('#option1').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 7) {
            $('#option1_error').html('')
            $('#option1').removeClass('error')
          }
        }
      } else {
        // if option 1 is not input
        if (index === -1 || index === 7) {
          $('#option1_error').html('')
          $('#option1').removeClass('error')
        }
      }
      if (this.userInfor.option2 !== null && this.userInfor.option2 !== '') {
        if (this.userInfor.option2.length > 64) {
          if (index === -1 || index === 8) {
            $('#option2_error').html('備考は64文字以内で入力してください。')
            $('#option2').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 8) {
            $('#option2_error').html('')
            $('#option2').removeClass('error')
          }
        }
      } else {
        // if option 2 is not input
        if (index === -1 || index === 8) {
          $('#option2_error').html('')
          $('#option2').removeClass('error')
        }
      }
      if (this.userInfor.phoneNumber !== null && this.userInfor.phoneNumber.trim() !== '') {
        if (!this.userInfor.phoneNumber.match(/^[0][0-9]{10}$/)) {
          if (index === -1 || index === 9) {
            $('#phonenumber_error').html('入力された電話番号は無効です。<br> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
            $('#phonenumber').addClass('error')
          }
          this.flag += 1
        } else {
          if (index === -1 || index === 9) {
            $('#phonenumber_error').html('')
            $('#phonenumber').removeClass('error')
          }
        }
      } else {
        if (index === -1 || index === 9) {
          if (!this.userInfor.isMfaSms) {
            $('#phonenumber_error').html('')
            $('#phonenumber').removeClass('error')
          } else {
            this.flag += 1
            $('#phonenumber_error').html('入力された電話番号は無効です。<br> 0から始まる-(ハイフン)無しの携帯電話番号を11桁で入力してください。')
            $('#phonenumber').addClass('error')
          }
        }
      }

      // if (this.userInfor.thumbnail !== null && this.userInfor.thumbnail !== '') {
      if (vm.fileTmp !== null && vm.fileTmp !== '') {
        var fileimg = vm.fileTmp
        if (this.imgWidth > 150 || this.imgHeight > 150) {
          // width or height > 150
          this.errorMessageLogs = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          // this.flag += 1
          this.message = ''
        } else if (fileimg.type !== 'image/png') {
          // type is not image/png
          this.errorMessageLogs = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          // this.flag += 1
          this.message = ''
        } else if (fileimg.size > 65536) {
          // size > 65536
          this.errorMessageLogs = '登録できる画像は、「ファイル形式：png、縦150×横150、ファイルサイズは64kバイト」となります。'
          $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
            $('#error-alert').slideUp(500)
          })
          // this.flag += 1
          this.message = ''
        } else {
          this.errorMessageLogs = ''
          this.getBase64(vm.fileTmp)
          vm.converImgtpBase64(vm.fileTmp)
        }
      }
      this.isEnabledSave = false
      if (this.flag === 0 && this.flagU && this.flagP) {
        this.isEnabledSave = true
      }
    },
    yesChoice () {
      this.userInfor.isSendEmail = true
      this.loading = true
      this.addUser()
    },
    noChoice () {
      this.userInfor.isSendEmail = false
      this.loading = true
      this.addUser()
    },
    submitAddUser () {
      if (this.userInfor.email !== null && this.userInfor.email !== '') {
        $('#confirm').click()
      } else {
        this.anwser = true
        this.loading = true
        this.addUser()
      }
    },
    addUser () {
      this.message = ''
      this.sucessStatus = false
      this.errorMessageLogs = ''
      var OuserInfor = {
        userId: this.userInfor.userId,
        password: this.userInfor.password
      }
      if (this.userInfor.name !== null && this.userInfor.name !== '') {
        OuserInfor.name = this.userInfor.name
      }
      if (this.userInfor.furigana !== null && this.userInfor.furigana !== '') {
        OuserInfor.furigana = this.userInfor.furigana
      }
      if (this.userInfor.email !== null && this.userInfor.email !== '') {
        OuserInfor.email = this.userInfor.email
      }
      OuserInfor.isSendEmail = this.userInfor.isSendEmail
      if (this.userInfor.phoneNumber !== null && this.userInfor.phoneNumber !== '' && this.userInfor.isMfaSms === true) {
        var phoneSelft = this.userInfor.phoneNumber.substring(1)
        OuserInfor.phoneNumber = '+81' + phoneSelft
      }
      if (this.userInfor.thumbnail !== null && this.userInfor.thumbnail !== '') {
        OuserInfor.thumbnail = this.userInfor.thumbnail
      }
      if (this.userInfor.passCode !== null && this.userInfor.passCode !== '') {
        OuserInfor.passCode = this.userInfor.passCode
      }
      if (this.userInfor.isMfaSms !== null && this.userInfor.isMfaSms !== '') {
        OuserInfor.isMfaSms = this.userInfor.isMfaSms
      }
      if (this.userInfor.isAdmin !== null && this.userInfor.isAdmin !== '') {
        OuserInfor.isAdmin = this.userInfor.isAdmin
      }
      if (this.userInfor.isPhoneAdmin !== null && this.userInfor.isPhoneAdmin !== '') {
        OuserInfor.isPhoneAdmin = this.userInfor.isPhoneAdmin
      }
      if (this.userInfor.shareKeyBeValid !== null && this.userInfor.shareKeyBeValid !== '') {
        OuserInfor.shareKeyBeValid = this.userInfor.shareKeyBeValid
      }
      if (this.userInfor.isValid !== null && this.userInfor.isValid !== '') {
        OuserInfor.isValid = this.userInfor.isValid
      }
      if (this.userInfor.option1 !== null && this.userInfor.option1 !== '') {
        OuserInfor.option1 = this.userInfor.option1
      }
      if (this.userInfor.option2 !== null && this.userInfor.option2 !== '') {
        OuserInfor.option2 = this.userInfor.option2
      }
      console.log(JSON.stringify(OuserInfor))
      this.$http.post(Config.USERS_LIST_API, JSON.stringify(OuserInfor))
        .then(response => {
          console.log(response)
          if (response.body.message === 'Success') {
            this.userId = OuserInfor.userId
            // this.reset()
            // this.message = Config.ADD_USER_API_SUCCESS
            this.startAddGroup = true
          } else {
            this.loading = false
            this.error = true
            this.errorMessageLogs = Config.ADD_USER_API_ERROR
          }
        })
        .catch((error) => {
          this.loading = false
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 409:
              this.errorMessageLogs = '入力されたユーザーIDは既に使用されています。他のユーザーIDを入力してください。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    reloadPcodeList () {
      this.isReloadPcodeList = true // trigger
    },
    pCodeChangeConfirm () {
      this.validateBeforeSubmit(-1)
      if (this.isEnabledSave === true) {
        if (this.assignedPcode.length > 0) {
          $('#pCode-change').modal({
            backdrop: 'static',
            keyboard: false
          })
        } else {
          this.submitAddUser()
        }
      }
    }
  }
}
</script>

<style type="text/css">

.warringu{
  padding-left:5px;
}
#error-alert, #success-alert {
  display: none;
}
textarea.error {
  border:1px solid red;
}
span.error_m {
  font-size: 15px;
  font-weight: normal;
  color: #FF4040;
  display: block;
  margin: 0;
}
.cusrow{
  padding: 6px 4px 6px 6px;
  width: 95%;
  margin-right: 10px;
  border-top: 1px dotted #D5E4F1;
}
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .register_user .profile-info-name{
    text-align: left;
    width: 225px
  }
  .userav input[type=file] {
    margin: 0 auto
  }
  span.error {
  color: red;
}
input.error {
  border: 1px solid red;
}
#gate-list .modal-body {
    height: 250px;
    overflow-y: auto;
  }
  #gate-list .modal-content {
    width: 768px;
    overflow-y: auto;
  }
  #gate-list .modal-header h3.frofile-title{
    padding-bottom: 10px
  }
  #gate-list .modal-header {
    padding: 10px 15px;
  }
#pCode-list .modal-body {
  height: 250px;
  overflow-y: auto;
}
#pCode-list .modal-content {
  width: 768px;
  overflow-y: auto;
}
#pCode-list .modal-header h3.frofile-title{
  padding-bottom: 10px
}
#pCode-list .modal-header {
  padding: 10px 15px;
}
.modal-content {
    background-clip: border-box !important;
}

@media only screen and (max-width: 1300px){
  #user_avatar {
    width: 100% !important;
    height: auto !important
  }
}

</style>



// WEBPACK FOOTER //
// src/views/user/UserAdd.vue